import React, { useEffect, useState } from "react";
import ArtistList from "../../../components/artist/artistList";
import Loader from "../../../components/loader";
import SearchBar from "../../../components/searchBar";
import { useDashboardContext } from "../../../context/dashboardContext";
import { AccountAdminResponseDTOMin, ArtistResponseDTOMin } from "../../../openapi-generated-client";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import { useNavigate } from "react-router-dom";

import "./dashboardAccountManagementPage.css";

export default function DashboardAccountManagementPage() {

    const navigate = useSafeNavigate(useNavigate());

    const {sessionId, appContext} = useDashboardContext();
    const {accountController} = appContext;

    const [search, setSearch] = React.useState("");

    const [data, setData] = useState<AccountAdminResponseDTOMin[]>();

    async function fetchArtists() {
        setData((await accountController.getAllAccounts(sessionId)).data);
    }

    useEffect(() => {
        fetchArtists();
    }, [])

    if(data == undefined) return <Loader/>;

    return <div className="page">
            <SearchBar search={search} onSearch={setSearch}/>
            <div className="account-list">
                {data.map((account) => {
                    return <div className="account-item" onClick={() => {
                        navigate(account.accountId.toString());
                    }}>
                        {account.email}
                        </div>;

                })}
            </div>
        </div>;

}